import { Link } from "@/i18n/routing";
import type { PropsWithChildren } from "react";

export const LinkWrapper = ({
	children,
	href,
}: PropsWithChildren<{
	href?: string;
}>) => {
	const style = { display: "contents" };

	if (href) {
		return (
			<Link href={href} style={style}>
				{children}
			</Link>
		);
	}
	return <div style={style}>{children}</div>;
};
